const data = {
  title: "Floor 1-4",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 12,
  tilesHeight: 3,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 11,
      y: 2,
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 2,
      isRaised: true,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "CHIP",
      x: 5,
      y: 3,
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 3,
      isRaised: false,
    },
    {
      type: "SWITCH",
      x: 4,
      y: 3,
    },
  ],
};

export default data;
